// src/App.js
import * as React from "react";
// import { Admin, Resource, ListGuesser, fetchUtils, CustomRoutes, Route } from "react-admin";
import { Admin, Resource, ListGuesser, fetchUtils, CustomRoutes } from "react-admin";
import { Route } from 'react-router-dom';
// ...其他代码...
import simpleRestProvider from "ra-data-simple-rest";
import authProvider from "./authProvider.js";
import { useEffect, useState } from "react";
// 导入缓存管理器
import { CacheManager, PermissionChangeListener } from "./services/cacheManager.ts";
// import { fetchMenuTree } from "./services/menuService.ts";
import MaterialList from "./pages/Material/MaterialList.js";
import MaterialEdit from "./pages/Material/MaterialEdit.tsx";
import MaterialCreate from "./pages/Material/MaterialCreate.tsx";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import BuildIcon from "@mui/icons-material/Build";
import BusinessIcon from "@mui/icons-material/Business";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CustomLayout from './components/Layout.tsx';
import CustomLayoutWrapper from './components/CustomLayoutWrapper.tsx';
import AutoMenuNavigator from './components/AutoMenuNavigator.tsx';

import BomList from "./pages/BOM/BomList.tsx";
import BomCreate from "./pages/BOM/BomCreate.tsx";
import BomEdit from "./pages/BOM/BomEdit.tsx";
import BomChartPage from "./pages/BOM/BomChartPage.tsx";
import SalesChartPage from "./pages/Sales/SalesChartPage.tsx";
import SalesList from "./pages/Sales/SalesList.tsx";
import SalesCreate from "./pages/Sales/SalesCreate.tsx";
import SalesEdit from "./pages/Sales/SalesEdit.tsx";
import StockList from "./pages/Stock/StockList.tsx";
import StockCreate from "./pages/Stock/StockCreate.tsx";
import StockEdit from "./pages/Stock/StockEdit.tsx";
import MyLoginPage from "./pages/login/MyLoginPage.tsx";
import SupplierList from "./pages/Supplier/SupplierList.tsx";
import SupplierCreate from "./pages/Supplier/SupplierCreate.tsx";
import SupplierEdit from "./pages/Supplier/SupplierEdit.tsx";
import SendEmail from "./pages/Supplier/SendEmail.tsx";
import PurchasePlanWizard from "./pages/PurchaseOrderPlan/PurchasePlanWizard.tsx";
import CalculatePage from "./pages/Calculate/CalculatePage.tsx";
import CalculateIcon from "@mui/icons-material/Calculate"; // 使用一个合适的图标

import './App.css';
import theme from "./theme.js";
import Dashboard from "./pages/Dashboard/DashboardPage.tsx"; // Add this import
import { FileTextIcon } from "lucide-react";
import ProDoc from "./pages/prodoc/Prodoc.tsx";
import InventoryIcon from "@mui/icons-material/Inventory";
import DescriptionIcon from "@mui/icons-material/Description";
import ProductList from "./pages/prodoc/ProductList.tsx";
import ProductEdit from "./pages/prodoc/ProductEdit.tsx";
import ProductCreate from "./pages/prodoc/ProductCreate.tsx";

import CustomerList from "./pages/prodoc/CustomerList.tsx";
import CustomerEdit from "./pages/prodoc/CustomerEdit.tsx";
import CustomerCreate from "./pages/prodoc/CustomerCreate.tsx";

import UserList from "./pages/RBAC/User/UserList.tsx";
import UserEdit from "./pages/RBAC/User/UserEdit.tsx";
import UserCreate from "./pages/RBAC/User/UserCreate.tsx";
import DepartmentList from "./pages/RBAC/Department/DepartmentList.tsx";
import DepartmentEdit from "./pages/RBAC/Department/DepartmentEdit.tsx";
import DepartmentCreate from "./pages/RBAC/Department/DepartmentCreate.tsx";
import RoleList from "./pages/RBAC/Role/RoleList.tsx";
import RoleEdit from "./pages/RBAC/Role/RoleEdit.tsx";
import ActionList from "./pages/RBAC/Action/ActionList.tsx";
import ActionEdit from "./pages/RBAC/Action/ActionEdit.tsx";
import ActionCreate from "./pages/RBAC/Action/ActionCreate.tsx";
import MenuList from "./pages/RBAC/Menu/MenuList.tsx";
import MenuEdit from "./pages/RBAC/Menu/MenuEdit.tsx";
import MenuCreate from "./pages/RBAC/Menu/MenuCreate.tsx";


import DocumentList from "./pages/prodoc/DocumentList.tsx";
import DocumentEdit from "./pages/prodoc/DocumentEdit.tsx";
import DocumentCreate from "./pages/prodoc/DocumentCreate.tsx";
import DocumentManageList from "./pages/documents/DocumentManageList.tsx";
import DocumentManageCreate from "./pages/documents/DocumentManageCreate.tsx";
import DocumentManageEdit from "./pages/documents/DocumentManageEdit.tsx";
import DocumentManageDetail from "./pages/documents/DocumentManageDetail.tsx";
import MaterialCostEdit from "./pages/BOMCost/MaterialCostEdit.tsx";
import MaterialCostCreate from "./pages/BOMCost/MaterialCostCreate.tsx";
import MaterialCostList from "./pages/BOMCost/MaterialCostList.tsx";
import BomCostEdit from "./pages/BOMCost/BomCostEdit.tsx";
import BomCostCreate from "./pages/BOMCost/BomCostCreate.tsx";
import BomCostList from "./pages/BOMCost/BomCostList.tsx";
import MyApprovalTasks from "./pages/Workflow/Mytask/MytaskList.tsx";
import MytaskView from "./pages/Workflow/Mytask/MytaskView.tsx";
import TemplateList from "./pages/Workflow/Template/TemplateList.tsx";
import TemplateCreate from "./pages/Workflow/Template/TemplateCreate.tsx";
import TemplateEdit from "./pages/Workflow/Template/TemplateEdit.tsx";

import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enUS } from 'date-fns/locale/en-US';
import RoleCreate from "./pages/RBAC/Role/RoleCreate.tsx";

const i18nProvider = polyglotI18nProvider(() => englishMessages, 'en');
const fetchJsonWithAuth = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem("token");
  if (token) {
    options.headers.set("Authorization", `Bearer ${token}`);
  }
  // 添加错误处理
  return fetchUtils.fetchJson(url, options).catch((error) => {
    const status = error.status || (error.response && error.response.status);

    if (status === 401 || status === 403) {
      return Promise.reject({ status, message: 'Unauthorized' });
    }

    if (error instanceof TypeError) {
      return Promise.reject({ status: 0, message: 'Network error or server down' });
    }

    return Promise.reject(error);
  });
};
const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5180/api";
const baseProvider = simpleRestProvider(`${apiUrl}`, fetchJsonWithAuth); // 后端 API 地址

// 包装一层，覆盖 deleteMany
const dataProvider = {
  ...baseProvider,

  deleteMany: async (resource, params) => {
    const token = localStorage.getItem("token"); // 获取 token
    const headers = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
    });

    if (token) {
      headers.set("Authorization", `Bearer ${token}`); // 添加 Authorization 头
    }

    const { json } = await fetch(`${apiUrl}/${resource}/batchDelete`, {
      method: "POST",
      headers,
      body: JSON.stringify(params.ids), // 传递要删除的 ID 列表,
    });

    return { data: params.ids };
  },
}
const App = () => {
  // const [menuTree, setMenuTree] = useState([]);
  // useEffect(() => {
  //   fetchMenuTree().then(setMenuTree);
  // }, []);

  // 初始化缓存管理器和事件监听器
  useEffect(() => {
    // 在浏览器 console 输出调试信息
    // eslint-disable-next-line no-console
    console.log('[App] Cache management initialized');
    // eslint-disable-next-line no-console
    console.log('[App] Use window.__cacheDebug to manage caches');

    // 注册权限变更监听器（可以集成 WebSocket 或事件总线）
    PermissionChangeListener.on('userPermissionChanged', (data) => {
      // eslint-disable-next-line no-console
      console.log('[App] User permission changed:', data);
    });

    PermissionChangeListener.on('rolePermissionChanged', (data) => {
      // eslint-disable-next-line no-console
      console.log('[App] Role permission changed:', data);
    });

    PermissionChangeListener.on('menuPermissionChanged', (data) => {
      // eslint-disable-next-line no-console
      console.log('[App] Menu permission changed:', data);
    });

    return () => {
      // 清理监听器
    };
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
      <Admin
        i18nProvider={i18nProvider}
        theme={theme}
        layout={CustomLayout}
        authProvider={authProvider}
        dataProvider={dataProvider}
        // dashboard={Dashboard}
        loginPage={MyLoginPage}
        queryClientOptions={{
          defaultOptions: {
            queries: {
              retry: false,
              staleTime: 0,
              refetchOnWindowFocus: true,
              refetchOnReconnect: true,
            },
          },
        }}
      >
      <Resource name="permissionUsers" list={UserList} edit={UserEdit} create={UserCreate} />
      <Resource name="permissionDepartment" list={DepartmentList} edit={DepartmentEdit} create={DepartmentCreate} />
      <Resource name="permissionRoles" list={RoleList} edit={RoleEdit} create={RoleCreate} />
      <Resource name="permissionActions" list={ActionList} edit={ActionEdit} create={ActionCreate} />
      <Resource name="permissionMenus" list={MenuList} edit={MenuEdit} create={MenuCreate} />
      <Resource icon={Inventory2Icon} name="Materials" list={(props) => (
        <MaterialList {...props} />
      )} create={MaterialCreate}
        edit={MaterialEdit} options={{ label: "Items" }} />

      <Resource icon={BuildIcon} name="BOM"
        list={(props) => (
          <BomList {...props} />
        )}
        //  <CustomLayoutWrapper></CustomLayoutWrapper>
        create={BomCreate}
        edit={BomEdit} />
      {/* 你可以在这里注册自定义路由 */}
      <CustomRoutes>
        <Route path="/" element={<AutoMenuNavigator />} />
        <Route path="/bom/:id/chart" element={<BomChartPage />} />
      </CustomRoutes>
      <CustomRoutes>
        <Route path="/sales/chart" element={<SalesChartPage />} />
        <Route path="/supplier/send-email" element={<SendEmail />} />
        <Route path="/mytask/:id/view" element={<MytaskView />} />
      </CustomRoutes>

      <Resource icon={ReceiptLongIcon} list={(props) => (
        <SalesList {...props} />
      )} create={SalesCreate} edit={SalesEdit} name="Sales" options={{ label: "Sales Order" }} />
      <Resource create={StockCreate} edit={StockEdit} options={{ label: "Inventory" }} icon={WarehouseIcon} name="Stock" list={(props) => (
        <StockList {...props} />
      )} />
      
      <Resource icon={BusinessIcon} edit={SupplierEdit} name="Supplier" options={{ label: "Supplier" }} list={(props) => (
        <CustomLayoutWrapper>
          <SupplierList {...props} />
        </CustomLayoutWrapper>
      )} create={SupplierCreate} />

      <Resource icon={AssignmentIcon} name="PurchaseOrderPlan" options={{ label: "Purchase Plan" }} list={(props) => (
        <PurchasePlanWizard {...props} />
      )} />

      <Resource
        icon={<CalculateIcon sx={{ color: '#0b3d2e' }} />}
        name="Calculate"
        options={{ label: "Calculate" }}
        list={(props) => (
          <CustomLayoutWrapper>
            <CalculatePage {...props} />
          </CustomLayoutWrapper>
        )}
      />

      {/* <Resource
      icon={FileTextIcon}
      name="ProDoc"
      options={{ label: "Pro Document" }}
      list={(props) => (
        <CustomLayoutWrapper>
          <ProDoc {...props} />
        </CustomLayoutWrapper>
      )}
    /> */}

      {/* Prodoc 下的 Product */}
      <Resource
        name="prodocProducts"          // 这里的 name 决定了路由 /products
        // name="Prodoc"
        list={(props) => (
          <ProductList {...props} />
        )}
        create={ProductCreate}   // 新建页面
        edit={ProductEdit}       // 编辑页面
        options={{ label: "Products", menu: null }} // 菜单显示名称（可选）
      />

      <Resource
        name="prodocCustomer"          // 这里的 name 决定了路由 /products
        list={(props) => (
          <CustomerList {...props} />
        )}
        create={CustomerCreate}   // 新建页面
        edit={CustomerEdit}       // 编辑页面
        options={{ label: "Customers", menu: null }} // 菜单显示名称（可选）
      />

      <Resource
        name="prodocDocument"          // 这里的 name 决定了路由 /products
        list={(props) => (
          <DocumentList {...props} />
        )}
        create={DocumentCreate}   // 新建页面
        edit={DocumentEdit}       // 编辑页面
        options={{ label: "Documents", menu: null }} // 菜单显示名称（可选）
      />


      <Resource
        name="documentsList"          // 这里的 name 决定了路由 /bomCost
        list={(props) => (
          <DocumentManageList {...props} />
        )}
        show={(props) => (        
          <DocumentManageDetail {...props} />
        )}
        create={DocumentManageCreate}   // 新建页面
        edit={DocumentManageEdit}       // 编辑页面
        options={{ label: "ProductCost", menu: null }} // 菜单显示名称（可选）
      />

      {/* <Resource
        name="materialCost"          // 这里的 name 决定了路由 /materialCost

        list={(props) => (

          <MaterialCostList {...props} />

        )}
        create={MaterialCostCreate}   // 新建页面
        edit={MaterialCostEdit}       // 编辑页面
        options={{ label: "MaterialCost", menu: null }} // 菜单显示名称（可选）
      /> */}

            {/* workflow 下的 Mytask */}
      <Resource
        name="workflowMytask"          // menu跳转
        list={(props) => (
          <MyApprovalTasks {...props} />
        )}
        // create={MytaskCreate}   // 新建页面
        // edit={MytaskEdit}       // 编辑页面
        options={{ label: "MyTasks", menu: null }} // 菜单显示名称（可选）
      />

      <Resource
        name="QmsWorkflowTemplate"          // menu跳转
        list={(props) => (
          <TemplateList {...props} />
        )}
        create={TemplateCreate}   // 新建页面
        edit={TemplateEdit}       // 编辑页面
        options={{ label: "Templates", menu: null }} // 菜单显示名称（可选）
      />
      </Admin>
    </LocalizationProvider>
  );
};

export default App;
